export interface BannerMobileLocalizable {
  bannerLocalizableId?: string;
  url?: string;
  firstHeader: string;
  header: string;
  culture: string;
}

export interface DefaultImageList {
	[key: string]: string;
	imageUrl: string;
}

export const defaultBannerMobileLocalizableData: BannerMobileLocalizable[] = [
	{
		bannerLocalizableId: "",
		url: "",
		firstHeader: "",
		header: "",
		culture: "tr-TR"
	},
	{
		bannerLocalizableId: "",
		url: "",
		firstHeader: "",
		header: "",
		culture: "en-US"
	}
];

/* -------------- Operation based interfaces -------------- */

// LIST
export interface BannerMobileListItem {
	bannerId: string;
	displayOrder?: number;
	hasMenu: boolean;
	isActive: boolean;
	isUpper: boolean;
	firstHeader: string;
	creationDate: string;
}

export interface BannerMobileListApiResponse {
	result: {
		items: BannerMobileListItem[];
	};
	error: string | null;
	isSuccessful: boolean;
}

// GET
export interface BannerMobileDetail {
	bannerId: string;
	imageList: DefaultImageList;
	isActive: boolean;
	isUpper: boolean;
	hasNavigation: boolean;
	displayOrder?: number;
	bannerMobileLocalizable: BannerMobileLocalizable[];
}

export interface BannerMobileGetApiResponse {
	result: {
		bannerId: string;
		imageUrl: string;
		isActive: boolean;
		isUpper: boolean;
		hasNavigation: boolean;
		displayOrder?: number;
		bannerMobileLocalizable: BannerMobileLocalizable[];
	}
	error: string | null;
	isSuccessful: boolean;
}

// ORDER
export interface BannerMobileOrderItem {
	bannerId: string;
	displayOrder?: number;
}

// ADD/UPDATE
export interface BannerMobileFormData {
	bannerId?: string;
	isActive: boolean | undefined;
	isUpper: boolean | undefined;
	hasNavigation: boolean | undefined;
	images: {
		image: File | null;
	}
    bannerMobileLocalizable: BannerMobileLocalizable[];
}

export const defaultBannerMobileFormData: BannerMobileFormData = {
	bannerId: "",
	images: {
		image: null,
	},
	isActive: undefined,
	isUpper: undefined,
	hasNavigation: undefined,
	bannerMobileLocalizable: defaultBannerMobileLocalizableData
};

// Page States
export type OperationStatus =
	| { type: "idle" }
	| { type: "loading"; operation: "add" | "fetch" | "update" | "delete" }
	| { type: "error"; operation: string; message: string };

